var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledUmbrellaBeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4494_6134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.374 17.6445L16.896 16.3613L12.7178 27.9688H2.18535C1.16104 27.9688 0.333496 28.8066 0.333496 29.8438C0.333496 30.8809 1.16104 31.7188 2.18535 31.7188H31.815C32.8393 31.7188 33.6668 30.8809 33.6668 29.8438C33.6668 28.8066 32.8393 27.9688 31.815 27.9688H16.6587L20.3682 17.6445H20.374ZM27.3821 17.6328L27.1911 18.166L31.109 19.6074C32.1564 19.9941 33.308 19.3613 33.4006 18.2363C33.7768 13.6367 32.0175 9.125 28.7247 6.01953C28.8404 6.48828 28.9099 6.97461 28.9215 7.47266L28.933 7.82422C29.0372 11.1641 28.5106 14.4922 27.3821 17.6328ZM27.0696 7.52539C27.006 5.50977 25.7675 3.72852 23.9215 2.99023C23.8694 2.9668 23.8115 2.94922 23.7594 2.92578C21.8497 2.24023 19.7201 2.78516 18.3717 4.32031L18.1402 4.58398C16.0974 6.89258 14.5117 9.58203 13.4585 12.5L13.2675 13.0332L25.4492 17.5215L25.6402 16.9883C26.6877 14.0703 27.1796 10.9824 27.0812 7.87695L27.0696 7.52539ZM6.5372 8.33398C5.89484 9.25391 6.37516 10.4902 7.42262 10.877L11.5314 12.3887L11.7224 11.8555C12.8509 8.71484 14.5638 5.82031 16.7629 3.33008L16.9944 3.06641C17.3532 2.66211 17.7525 2.30469 18.1807 2C13.5742 2.14648 9.22817 4.47266 6.5372 8.32813V8.33398Z",
    fill: "#FF6600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4494_6134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3333,
    height: 33.3333,
    fill: "white",
    transform: "translate(0.333496 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledUmbrellaBeach);
export default __webpack_public_path__ + "static/media/icon-filled-umbrella-beach.6075702403f1db9998f8d8a95262f8a9.svg";
export { ForwardRef as ReactComponent };